"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestrictionRuleItemMinMax = void 0;
const _1 = require("./");
const cloneModelObject_1 = require("../../../../../apis/spg/util/cloneModelObject");
/**
 * Restriction Rule: ItemMinMax
 *
 * This rule limits the minimum and/or maximum number allowed for a certain
 * item. For example For example, a burrito product blueprint comes with “guac“
 * as one of the topping options. It also comes with a ItemMinMax restriction
 * rule saying the maximum quantity of “guac“ allowed is 2. Given such a
 * blueprint, it would be a valid burrito build if the customer added 0-2
 * shares of guac. On the other hand, it would be an invalid burrito build
 * if the customer added 3 or more shares of guac as it breaks the ItemMinMax
 * restriction rule for guac.
 */
class RestrictionRuleItemMinMax {
    constructor(data) {
        this.name = _1.TRestrictionRuleName.itemMinMax;
        this.min = null;
        this.max = null;
        if (data) {
            this.productId = data.productId;
            this.min = data.min ? data.min : null;
            this.max = data.max ? data.max : null;
        }
    }
    filterSensitiveData() {
        const clone = (0, cloneModelObject_1.cloneModelObject)(this);
        return clone;
    }
    serialize() {
        return {
            name: this.name,
            productId: this.productId,
            min: this.min,
            max: this.max
        };
    }
    static unserialize(data) {
        const newRestrictionRuleItemMinMax = new this();
        newRestrictionRuleItemMinMax.productId = data.productId;
        newRestrictionRuleItemMinMax.min = data.min;
        newRestrictionRuleItemMinMax.max = data.max;
        return newRestrictionRuleItemMinMax;
    }
    isValid(products, productAvailability, selectedProducts) {
        const hitMax = this.hitMax(selectedProducts);
        const hitMin = this.hitMin(selectedProducts);
        const isValid = !hitMax && !hitMin;
        return isValid;
    }
    apply(products, productAvailability, selectedProducts) {
        const hitMax = this.hitMax(selectedProducts, true);
        const hitMin = this.hitMin(selectedProducts, true);
        if (hitMax) {
            // disable addition of the specified product once max is hit
            productAvailability.map(pa => {
                if (pa.productId === this.productId) {
                    pa.canAdd = false;
                }
            });
        }
        if (hitMin) {
            // disable removal of the specified product once min is hit
            productAvailability.map(pa => {
                if (pa.productId === this.productId) {
                    pa.canRemove = false;
                }
            });
        }
    }
    /**
     * Get the total number of the product specified by the restriction rule.
     */
    getQuantityForProduct(selectedProducts) {
        const selectedProduct = selectedProducts.find(sp => sp.product.productId === this.productId);
        return selectedProduct ? selectedProduct.quantity : 0;
    }
    /**
     * Check if the maximum is reached.
     */
    hitMax(selectedProducts, checkBoundary = false) {
        const quantity = this.getQuantityForProduct(selectedProducts);
        if (checkBoundary) {
            return this.max === null ? false : quantity >= this.max ? true : false;
        }
        else {
            return this.max === null ? false : quantity > this.max ? true : false;
        }
    }
    /**
     * Check if the minimum is reached.
     */
    hitMin(selectedProducts, checkBoundary = false) {
        const quantity = this.getQuantityForProduct(selectedProducts);
        if (checkBoundary) {
            return this.min === null ? false : quantity <= this.min ? true : false;
        }
        else {
            return this.min === null ? false : quantity < this.min ? true : false;
        }
    }
}
exports.RestrictionRuleItemMinMax = RestrictionRuleItemMinMax;
//# sourceMappingURL=RestrictionRuleItemMinMax.js.map